/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ProgramType, ProgramTypeFromJSON, ProgramTypeToJSON } from './'

/**
 *
 * @export
 * @interface EnrollmentInviteDashboard
 */
export interface EnrollmentInviteDashboard {
  /**
   * Unique identifier for the program the invite is sent.
   * @type {number}
   * @memberof EnrollmentInviteDashboard
   */
  programKey: number
  /**
   *
   * @type {ProgramType}
   * @memberof EnrollmentInviteDashboard
   */
  programType: ProgramType
  /**
   * Unique identifier of the community the enrollment invitation is within.
   * @type {number}
   * @memberof EnrollmentInviteDashboard
   */
  communityKey: number
  /**
   * Name of the community the enrollment invitation is for.
   * @type {string}
   * @memberof EnrollmentInviteDashboard
   */
  communityName: string
  /**
   * Year in which the invitation was sent
   * @type {number}
   * @memberof EnrollmentInviteDashboard
   */
  year: number
  /**
   * Total ENROLLED and PENDING enrollments
   * @type {number}
   * @memberof EnrollmentInviteDashboard
   */
  total: number
}

export function EnrollmentInviteDashboardFromJSON(
  json: any
): EnrollmentInviteDashboard {
  return EnrollmentInviteDashboardFromJSONTyped(json, false)
}

export function EnrollmentInviteDashboardFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EnrollmentInviteDashboard {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programKey: json['programKey'],
    programType: ProgramTypeFromJSON(json['programType']),
    communityKey: json['communityKey'],
    communityName: json['communityName'],
    year: json['year'],
    total: json['total'],
  }
}

export function EnrollmentInviteDashboardToJSON(
  value?: EnrollmentInviteDashboard | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programKey: value.programKey,
    programType: ProgramTypeToJSON(value.programType),
    communityKey: value.communityKey,
    communityName: value.communityName,
    year: value.year,
    total: value.total,
  }
}
